import { CacheService } from '../../core/storage/cacheService';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';

export class AssignedUser {
  public userId: string;
  public accessBits: string;
  public firstName: string;
  public lastName: string;
  public emailAddress: string;
  public phone: string | undefined;
  public fax: string | undefined;
  // public streetAddress: Partial<StreetAddress> | undefined;
  public contactTypes: string[] = [];

  static ALL_CONTACT_TYPES: ListItem[] = CacheService.contactTypesList;

  constructor(u: Partial<AssignedUser>) {
    if (u.userId == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n id cannot be null`,
      );
    if (u.emailAddress == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n emailAddress cannot be null`,
      );
    if (u.accessBits == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n accessBits cannot be null`,
      );
    if (u.firstName == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n firstName cannot be null`,
      );
    if (u.lastName == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n lastName cannot be null`,
      );
    //if (u.contactTypes == null)
    //    throw new Error(`Invalid user in constructor: ${JSON.stringify(u)}\n contactType cannot be null`);

    this.userId = u.userId;
    this.emailAddress = u.emailAddress;
    this.accessBits = u.accessBits;
    this.firstName = u.firstName;
    this.lastName = u.lastName;
    this.phone = u.phone;
    this.fax = u.fax;
    this.contactTypes = u.contactTypes || [];
    // this.streetAddress = u.streetAddress;
  }

  static createEmpty(): AssignedUser {
    return new AssignedUser({
      userId: '',
      accessBits: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      contactTypes: [],
      phone: '',
      fax: '',
    });
  }

  public static clone(userToCopy: Partial<AssignedUser>): AssignedUser {
    let sThisUser = JSON.stringify(userToCopy);
    return JSON.parse(sThisUser);
  }
}
